import cn from 'clsx'

import './Circle.scss'
import {Color} from 'common/types'

interface CircleProps {
  className?: string
  color?: Color
  border?: boolean
  hole?: boolean
  ripple?: boolean
}

export default function Circle({
  className,
  color = 'green',
  border,
  hole,
  ripple,
}: CircleProps) {
  return (
    <div
      className={cn(
        className,
        `Circle Circle_color_${color}`,
        border && 'Circle_border',
        hole && 'Circle_hole',
        ripple && 'Circle_ripple'
      )}
    />
  )
}
